<template lang="pug">
    m-form(ref="form" class="m-form-object-types")

        template(#content-template="")
            div(class="container-responsive")
                m-block-form-fields(child :tooltip="$t(`modules.forms.${name}.blocks.type.tooltip`)")
                    template(#title="") {{$t(`modules.forms.${name}.blocks.type.label`) }}

                    e-input-select-object-type(v-model="form.objectTypeId" :defaultModel="true")

</template>

<script>
    import baseForm from "@mixins/components/modules/forms/base";

    let name = 'm-form-object-types';

    export default {
        name: name,
        mixins: [baseForm],
        props: {
            name: {
                type: String,
                default: name
            },
            objectTypeId: {
                type: String
            },
            isOnboarding: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            form: {
                objectTypeId: null
            }
        }),
        created() {
            if(this.objectTypeId) {
                this.form.objectTypeId = this.objectTypeId
            }
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((success) => {
                    if (success) {
                        this.$emit('form:submit', this.form);
                    } else {
                        const el = document.querySelector(".v-messages__message");
                        el.scrollIntoView({behavior: "smooth" ,block: "center"});
                        this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
                    }
                });
            },
            cancel() {
                this.$emit('form:cancel', this.form);
            }
        }
    }
</script>

<style lang="scss">
    .container-responsive {
        @include media(md) {
            padding-left: 0 !important;
        }
    }
    .m-form-object-types {
        padding: 0 0 0 1rem !important;

        @media (max-width: $md) {
            padding: 0 !important;
        }

        .m-form-content-template {
            margin-top: 0;
            margin-bottom: 0;
        }
        .v-divider {
            display: none;
        }
    }
    .fullscreen {
        .m-form-object-types {
            padding: 0 !important;
        }
    }
</style>
